import React from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";

const EmptyCart = () => {
  const navigate = useNavigate();
  const handle_home = () => {
    navigate("/dashboard");
  };
  const handle_pickup = () => {
    navigate("/set-pickup-address");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-100 px-6 z-[10000]">
      <div
        className="bg-white rounded-xl shadow-3xl max-w-md overflow-x-hidden"
        style={{ boxShadow: "0px 0px 8px 0px rgba(166, 166, 166, 0.25)" }}
      >
        <div className="relative flex justify-center  ">
          <img src={ImageLinks.ellips_not_assign} className="w-[100%]" />
          <div className="w-12 h-12 flex items-center justify-center rounded-full absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 ">
            <img src={ImageLinks.info_light_yellow} />
          </div>
        </div>
        <div className="p-6 text-center mt-6 flex gap-2 flex-col">
          <p className="font-custom text-xl font-bold text-dark_black">
            Cart Unavailable
          </p>
          <p className="font-custom text-sm font-medium text-dark_black ">
            You haven’t added pickup & delivery address!
          </p>
        </div>
        <div className="flex w-full gap-3 justify-center px-6 mb-8">
          <button
            onClick={handle_home}
            className="font-custom text-base font-semibold btn w-[50%] text-secondary bg-white rounded-[30px] border-2	border-secondary"
          >
            Home
            {/* Cancel */}
          </button>
          <button
            onClick={handle_pickup}
            className="font-custom text-base font-semibold btn w-[50%] bg-primary text-white cursor-not-allowed rounded-[30px]"
          >
            Add Pickup
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;
